module.exports = __webpack_public_path__ + "img/floating-ball-ai-icon.e21b8662.png";